import TxpEntitiesState from 'txp-data/lib/schema/innerSchema/TxpEntitiesState';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';

export default function getTxpStatusUserVoiceData(
    txpStatus: TxpStatus
): {
    TXP_EntityStatus: string;
    TXP_ProcessingError: string;
    TXP_MigrationMode: string;
} {
    let state: string = null;
    let processingError: string = null;

    if (txpStatus.state != TxpEntitiesState.None) {
        state = TxpEntitiesState[txpStatus.state];
    }
    if (txpStatus.processingErrors) {
        processingError = txpStatus.processingErrors.replace(/\r\n/g, ' ');
    }

    return {
        TXP_EntityStatus: state,
        TXP_ProcessingError: processingError,
        TXP_MigrationMode: txpStatus.migrationMode,
    };
}
